import {FormControl, FormGroup} from '@angular/forms';

import {BaseControl, CheckboxControl} from 'appShared/classes/controls';

import {RemoveExchangesControls} from 'appAssets/descriptors';
import {ExchangeModel, HttpStatusCodesEnum, ServerResponse, ServerResponseData, SesService} from '@spa/api';
import {ColorCodesEnum, ComponentTypesEnum} from 'appShared/enums';
import {switchMap} from 'rxjs/operators';
import {Helper} from 'appShared/classes';
import {ExchangeFormErrorStatesEnum} from 'appEntries/panel/enums';
import {BaseMarketDataForm} from 'appShared/forms';

export class RemoveExchangeForm extends BaseMarketDataForm {
    private readonly exchanges: ExchangeModel[];

    constructor(sesService: SesService, exchanges: ExchangeModel[]) {
        super(sesService);
        this.exchanges = exchanges;
    }

    initForm(): void {
        this.formGroup = new FormGroup({});
        const exchangeControls = RemoveExchangesControls();

        for (const exchange of this.exchanges) {
            exchangeControls.push(
                new CheckboxControl({
                    name: `${exchange.id}`,
                    value: exchange.id,
                    placeholder: exchange.name,
                    nonCapitalizedPlaceholder: true,
                    validators: [],
                    componentType: ComponentTypesEnum.Checkbox,
                    floatingLabelNever: true,
                    checked: false,
                    color: ColorCodesEnum.Primary,
                    expectBooleanValue: false
                })
            );
        }

        this.controls = exchangeControls.map((control: BaseControl) => {
            this.formGroup.addControl(control.name, new FormControl(control.value, control.validators));

            return control;
        });
    }

    createRequest(): ServerResponse<boolean> {
        const ids: number[] = [];

        // tslint:disable-next-line:forin
        for (const property in this.formGroup.value) {
            const exchangeId = this.formGroup.value[property];
            if (exchangeId > 0) {
                ids.push(exchangeId);
            }
        }

        if (ids.length === 0) {
            return Helper.createSuccessResponseObservable<boolean>(true);
        }

        return this.sesService.deleteExchangeByIdList(ids).pipe(
            switchMap((response: ServerResponseData<any>) => {
                if (response && response.status !== HttpStatusCodesEnum.Ok) {
                    return Helper.errorsHelper().createErrorResponseObservable<any>(
                        response,
                        ExchangeFormErrorStatesEnum.DeleteExchangeFailed
                    );
                }

                return Helper.createSuccessResponseObservable<boolean>(true);
            }));
    }
}
